<ng-select 
    [items]="defaultBindingsList"
    [(ngModel)]="selectedCity">
</ng-select>

<br>
Selected city object: {{selectedCity | json}}